import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';
import { waitForProfile } from './shared.guard';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const notifications = inject(NotificationService);

  if (!authService.checkAuth()) {
    notifications.show(
      'login',
      'Inicia sesión',
      'Debes iniciar sesión para acceder a esta sección.',
    );
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  return waitForProfile((profile) => {
    if (profile) return true;

    authService.clearAuth();
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url },
    });
  });
};
